var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShopAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.5386 43.0093V60.2209C80.5386 77.4326 73.6768 84.3327 56.4268 84.3327H35.7653C33.542 84.3327 31.5102 84.2178 29.6318 83.9495",
    stroke: "#98A2B3",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6538 59.4928V43.0093",
    stroke: "#98A2B3",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1143 46.0003C53.1293 46.0003 58.3043 40.2889 57.6143 33.2739L55.0458 7.66699H37.1442L34.576 33.2739C33.886 40.2889 39.0994 46.0003 46.1143 46.0003Z",
    stroke: "#98A2B3",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2643 46.0003C78.0076 46.0003 83.6809 39.7136 82.9142 32.0086L81.8408 21.4669C80.4608 11.5002 76.6275 7.66699 66.5842 7.66699H54.8926L57.576 34.5387C58.266 40.8637 63.9393 46.0003 70.2643 46.0003Z",
    stroke: "#98A2B3",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7339 46.0003C28.0589 46.0003 33.7705 40.8637 34.3838 34.5387L35.2273 26.0672L37.0672 7.66699H25.3756C15.3323 7.66699 11.499 11.5002 10.119 21.4669L9.04556 32.0086C8.27889 39.7136 13.9906 46.0003 21.7339 46.0003Z",
    stroke: "#98A2B3",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4997 72.8333C34.4997 75.7083 33.6946 78.4302 32.2763 80.7302C31.5479 81.9569 30.6663 83.0684 29.6313 83.9501C29.5163 84.1034 29.4014 84.2183 29.248 84.3333C26.5647 86.7483 23.038 88.1667 19.1663 88.1667C14.4897 88.1667 10.3112 86.0582 7.55123 82.7615C7.47456 82.6465 7.35977 82.57 7.2831 82.455C6.8231 81.9184 6.40141 81.3436 6.05641 80.7302C4.63807 78.4302 3.83301 75.7083 3.83301 72.8333C3.83301 68.0033 6.05634 63.6717 9.58301 60.8734C10.2347 60.3367 10.9246 59.8767 11.6529 59.4934C13.8763 58.2284 16.4447 57.5 19.1663 57.5C22.9997 57.5 26.4496 58.8799 29.1329 61.2182C29.5929 61.5632 30.0146 61.9851 30.398 62.4068C32.928 65.1668 34.4997 68.8083 34.4997 72.8333Z",
    stroke: "#98A2B3",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8774 72.7568H13.4541",
    stroke: "#98A2B3",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.167 67.1602V78.6218",
    stroke: "#98A2B3",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopAdd);
export default __webpack_public_path__ + "static/media/shop-add.fce9f0bc0cea9e588956c4c207cd708c.svg";
export { ForwardRef as ReactComponent };